import state from './moduleEnterpriseMapSettingState.js'
import mutations from './moduleEnterpriseMapSettingMutations.js'
import actions from './moduleEnterpriseMapSettingActions.js'
import getters from './moduleEnterpriseMapSettingGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
